import { Switch } from 'react-router-dom';
import { Routing as DistributorsRouting } from 'modules/Distributors';
import { Routing as ProductsRouting } from 'modules/Products';
import { Routing as RefundsRoutingRedesign } from 'modules/Refunds';
import { Routing as UsersManagementRouting } from 'modules/UsersManagement';
import { Features } from 'types/features/enums';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { useAreFeaturesLoaded } from 'api/FeatureFlags/queries';
import { PublicRouting } from './PublicRouting';
import { ActivityRouting } from './routes/activity';
import { CouponsRouting } from './routes/coupons';
import { CustomPlansManagementRouting } from './routes/customPlansManagement';
import { MembersRouting } from './routes/members';
import { OrganizationsRouting } from './routes/organizations';
import { PartnersRouting } from './routes/partners';
import { RefundsRouting } from './routes/refunds';
import { ResellersRouting } from './routes/resellers';
import { ServersRouting } from './routes/servers';
import { UsersManagementOldRouting } from './routes/users';
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseRouting = function BaseRouting() {
    var areFeaturesLoaded = useAreFeaturesLoaded();
    var isMembersRedesignEnabled = useFeatureFlag(Features.MembersRedesign);
    var isServersRedesignEnabled = useFeatureFlag(Features.ServersRedesign);
    var isActivityRedesignEnabled = useFeatureFlag(Features.ActivityRedesign);
    var isUsersManagementEnabled = useFeatureFlag(Features.UsersManagement);
    var shouldRenderRedesignedUsersManagement = areFeaturesLoaded && isUsersManagementEnabled;
    var isDistributorsEnabled = useFeatureFlag(Features.Distributors);
    var shouldRenderDistributors = areFeaturesLoaded && isDistributorsEnabled;
    var isMspPartnersEnabled = useFeatureFlag(Features.MspPartnersRedesign);
    var isRefundsRedesignEnabled = useFeatureFlag(Features.RefundsRedesign);
    var isOrdersRedesignEnabled = useFeatureFlag(Features.OrdersRedesign);
    var isProductsEnabled = useFeatureFlag(Features.MultiProductProductsPage);
    var shouldRenderProducts = areFeaturesLoaded && isProductsEnabled;
    var isPackageProductSelectionEnabled = useFeatureFlag(Features.PackageProductSelection);
    var isPlanProductSelectionEnabled = useFeatureFlag(Features.PlanProductSelection);
    var isPackagesListRedesignEnabled = useFeatureFlag(Features.PackagesListRedesign);
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [PartnersRouting({
                areFeaturesLoaded: areFeaturesLoaded,
                isMspPartnersEnabled: isMspPartnersEnabled
            }), ResellersRouting(), OrganizationsRouting({
                areFeaturesLoaded: areFeaturesLoaded,
                isOrdersRedesignEnabled: isOrdersRedesignEnabled
            }), MembersRouting({
                areFeaturesLoaded: areFeaturesLoaded,
                isMembersRedesignEnabled: isMembersRedesignEnabled
            }), ServersRouting({
                areFeaturesLoaded: areFeaturesLoaded,
                isServersRedesignEnabled: isServersRedesignEnabled
            }), areFeaturesLoaded && isRefundsRedesignEnabled ? RefundsRoutingRedesign() : RefundsRouting(), CouponsRouting(), CustomPlansManagementRouting({
                areFeaturesLoaded: areFeaturesLoaded,
                isPackageProductSelectionEnabled: isPackageProductSelectionEnabled,
                isPlanProductSelectionEnabled: isPlanProductSelectionEnabled,
                isPackagesListRedesignEnabled: isPackagesListRedesignEnabled
            }), ActivityRouting({
                areFeaturesLoaded: areFeaturesLoaded,
                isActivityRedesignEnabled: isActivityRedesignEnabled
            }), shouldRenderRedesignedUsersManagement ? UsersManagementRouting() : UsersManagementOldRouting(), shouldRenderDistributors && DistributorsRouting(), shouldRenderProducts && ProductsRouting(), PublicRouting() /* Must be last for 404 rendering */]
    });
};
